//import 'antd/dist/antd.css';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Router, BrowserRouter } from "react-router-dom";
import { store, StoreContext } from "./app/stores/store";
import { createBrowserHistory, createHashHistory } from "history";
import { BASENAME } from './config/constant';
import { SidebarProvider } from './contexts/SidebarContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
export const historys = createBrowserHistory({ basename: BASENAME });


ReactDOM.render(
  <StoreContext.Provider value={store}>
    <ConfigProvider>
      <Router history={historys} >
        <App />
      </Router>
    </ConfigProvider>
  </StoreContext.Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
